<template>
    <span
        v-if="count > 0"
        class="count-badge"
        :class="sizeClass"
        :style="badgeStyle"
    >
        {{ displayCount }}
    </span>
</template>

<script setup lang="ts">
    defineOptions({ name: 's-count-badge' })

    type Size = 'sm' | 'md' | 'lg'

    interface Props {
        /** 数量 */
        count: number
        /** 尺寸 */
        size?: Size
        /** 最大显示数量，超过显示 max+ */
        max?: number
        /** 背景色，默认主题色 */
        bgColor?: string
        /** 边框色，默认白色，设为 'none' 或空字符串则无边框 */
        borderColor?: string
    }

    const props = withDefaults(defineProps<Props>(), {
        size: 'sm',
        max: 99,
        bgColor: '',
        borderColor: '',
    })

    const displayCount = computed(() => {
        if (props.max && props.count > props.max) {
            return `${props.max}+`
        }
        return props.count
    })

    const sizeClass = computed(() => `count-badge--${props.size}`)

    const badgeStyle = computed(() => {
        const style: Record<string, string> = {}

        // 背景色：有传入用传入的，否则用主题色
        if (props.bgColor) {
            style.backgroundColor = props.bgColor
        }

        // 边框色：有传入用传入的
        if (props.borderColor && props.borderColor !== 'none') {
            style.borderColor = props.borderColor
            style.borderWidth = '2px'
            style.borderStyle = 'solid'
        }

        return style
    })
</script>

<style scoped lang="scss">
    $primary: var(--color-primary, #ff9e37);
    $white: #fff;

    .count-badge {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 9999px;
        font-weight: 900;
        color: $white;
        background-color: $primary;

        // 尺寸变体
        &--sm {
            top: -8px;
            right: -8px;
            min-width: 16px;
            height: 16px;
            padding: 0 4px;
            font-size: 9px;
        }

        &--md {
            top: -10px;
            right: -10px;
            min-width: 20px;
            height: 20px;
            padding: 0 4px;
            font-size: 10px;
        }

        &--lg {
            top: -12px;
            right: -12px;
            min-width: 24px;
            height: 24px;
            padding: 0 6px;
            font-size: 12px;
        }
    }
</style>
